import { Alert, Button, Spinner } from 'react-bootstrap';

export function LoadStatus({ loading, error, label, retry, quietLoading = false }: {
    quietLoading?: boolean;
    loading: boolean;
    error: boolean;
    label: string;
    retry: () => void;
}) {
    return <>
        {error && <Alert variant="warning" role="alert">
            Some {label} could not be loaded. <Button variant="link" onClick={retry}>Retry</Button>
        </Alert>}
        {loading && <div role="status" className={quietLoading ? "sr-only" : "py-2"}>
            <Spinner animation="border" size="sm" aria-hidden="true" /> Loading {label}…
        </div>}
    </>;
}
